const { server_ip }= require('../config');

export async function insertStudentAnswer(token, questionId, session, missionId, schoolMissionId, data){
    try {
        const response= await fetch(`${server_ip}/api2/studentAnswers`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                data:{
                    questionId, session, missionId, schoolMissionId, data
                }
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function studentFetchStudentAnswers(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/studentAnswers/student-fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherFetchStudentAnswers(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/studentAnswers/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}